import {cx} from "@emotion/css";
import {ReactComponent as SvgMapPin} from "assets/svg/map-pin.svg";

import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmMapPinIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgMapPin id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
